import _ from 'lodash';
import { apiSearch } from './utility';

export const searchStationHistory = (p = {}) => {
	const callback = p.callback || _.noop;
	const params = p.params || {};
	return dispatch => {
		apiSearch({
			method : 'station.history.search',
			base : 'stationHistory',
			dispatch : dispatch,
			params,
			callback : callback,
		});
	};
};
